/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gotsignedinfopostback3Inputs */

const de__field_gotsignedinfopostback3 = /** @type {(inputs: _Field_Gotsignedinfopostback3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwaltung hat unterschriebene Anmeldeunterlagen zurückerhalten`)
};

/**

* @param {_Field_Gotsignedinfopostback3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gotsignedinfopostback3 = /** @type {((inputs?: _Field_Gotsignedinfopostback3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gotsignedinfopostback3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_gotsignedinfopostback3(inputs)
});
export { _field_gotsignedinfopostback3 as "_field_gotSignedInfopostBack" }